<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Cadastro de Representante'">
          <template v-slot:preview>
            <v-form v-model="valid" ref="form">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="representante.nome"
                      label="Nome"
                      clearable
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="representante.cpfcnpj"
                      label="CPF/CNPJ"
                      clearable
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-btn @click="salvar" color="primary" large :disabled="saving"
                  >Salvar</v-btn
                >
              </v-container>
            </v-form>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <TelaLoading :overlay="saving"></TelaLoading>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";

export default {
  name: "representanteCadastro",
  data() {
    return {
      valid: false,
      saving: false,
      representante: {
        id: 0,
        nome: "",
        cpfcnpj: "",
      },
      rules: {
        required: (v) => !!v || "Obrigatório",
      },
    };
  },
  components: {
    KTCodePreview,
    TelaLoading,
  },
  methods: {
    salvar() {
      let self = this;

      if (this.$refs.form.validate()) {
        this.saving = true;

        if (this.representante.id === 0) {
          return new Promise((resolve) => {
            ApiService.post("representante", this.representante).then(
              ({ data }) => {
                resolve(data);
                if (data.success) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Representante Cadastrado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.$router.push({ name: "representante" });
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          }).finally(() => (this.saving = false));
        } else {
          return new Promise((resolve) => {
            ApiService.put(
              "representante/" + this.representante.id,
              this.representante
            ).then(({ data }) => {
              resolve(data);
              if (data.success) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Representante Alterado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.$router.push({ name: "representante" });
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          }).finally(() => (this.saving = false));
        }
      }
    },

    buscarRepresentante(id) {
      return new Promise((resolve) => {
        ApiService.get("representante/" + id).then(({ data }) => {
          resolve(data);

          if (data.success) this.representante = data.data;
          else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Representantes" }]);

    if (this.$route.params.id !== undefined)
      this.buscarRepresentante(this.$route.params.id);
  },
};
</script>
